import { render, staticRenderFns } from "./OptionSelected.vue?vue&type=template&id=cf86e4ba&scoped=true&"
import script from "./OptionSelected.vue?vue&type=script&lang=js&"
export * from "./OptionSelected.vue?vue&type=script&lang=js&"
import style0 from "./OptionSelected.vue?vue&type=style&index=0&id=cf86e4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf86e4ba",
  null
  
)

export default component.exports